export default __webpack_public_path__ + "static/media/cash_in_counter.255ed4de.svg";